var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "3" } },
            [
              _c("create-cost-center", {
                attrs: { "default-value": _vm.costCenterEdit },
                on: {
                  "update:defaultValue": function($event) {
                    _vm.costCenterEdit = $event
                  },
                  "update:default-value": function($event) {
                    _vm.costCenterEdit = $event
                  }
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "9" } },
            [
              _c("table-cost-center", {
                model: {
                  value: _vm.costCenterEdit,
                  callback: function($$v) {
                    _vm.costCenterEdit = $$v
                  },
                  expression: "costCenterEdit"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }